export default {
  "FoodOpC_Notifications_Full_time_tbyY": "All times",
  "FoodOpC_Notifications_No_order_CPhU": "No minimum order",
  "FoodOpC_Notifications_All_stores_lcyT": "All stores",
  "FoodOpC_Notifications_All_payments_ERiC": "All payment methods",
  "FoodOpC_Notifications_Full_service_HBkd": "All cities",
  "FoodOpC_Notifications_Some_stores_BdsO": "Only certain stores",
  "coupon": {
    "other": {
      "time": "Valid Until  {name} ",
      "hide": "Hide",
      "cost": "Applicable to  {name} ",
      "min": "over  {name} ",
      "show": "More Details",
      "cardBin": "Only available if the card bin is  {name} ",
      "limit": "{name}  Only",
      "new": "New Customer Only",
      "max": "Applicable to  {name} ",
      "off": "OFF",
      "limitUse": "{name}  Only",
      "use": "Available in  {name} "
    },
    "costType": {
      "order": "Order",
      "delivery": "Delivery Fee",
      "meals": "Food Fee"
    },
    "useRuleWeekDay": {
      "Monday": "Monday",
      "Thursday": "Thursday",
      "Saturday": "Saturday",
      "Tuesday": "Tuesday",
      "Sunday": "Sunday",
      "Friday": "Friday",
      "Wednesday": "Wednesday"
    },
    "payTypeList": {
      "all": "All Payments",
      "card": "Card",
      "pay": "99Pay - Balance",
      "pos": "POS Terminal",
      "money": "Cash"
    }
  }
}